<template>
  <el-row :gutter="20">
    <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
      网站云实例ID/名称：
      <el-link type="primary" :underline="false" style="margin-top: -5px" :href="getHostUrl()" target="_blank">
        {{ uniqueName }}
        <span v-if="nickName">（{{ nickName }}）</span>
      </el-link>
      <div style="height: 10px" />
      为站点设置自定义域名前，请确认已修改域名 DNS，增加域名 CNAME 解析至：
      <strong>{{ getCName() }}</strong>
      <el-link
        type="primary"
        :underline="false"
        style="margin-top: -5px; margin-left: 10px"
        href="https://sscms.com/docs/v7/host/essential/domain.html"
        target="_blank"
      >
        帮助文档
      </el-link>
    </el-col>
  </el-row>
  <div style="margin: 15px 30px 0">
    <el-table
      :data="domains"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column prop="domain" label="自定义域名">
        <template #default="scope">
          {{ scope.row.domain }}
        </template>
      </el-table-column>
      <el-table-column prop="domain" label="协议">
        <template #default="scope">
          {{ scope.row.https ? 'HTTPS' : 'HTTP' }}
        </template>
      </el-table-column>
      <el-table-column prop="prefix" label="前缀">
        <template #default="scope">
          {{ scope.row.prefix }}
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-divider></el-divider>
  <div style="margin: 15px 30px 0">
    <el-table
      :data="certs"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column prop="domainName" label="HTTPS域名">
        <template #default="scope">
          {{ scope.row.domainName }}
        </template>
      </el-table-column>
      <el-table-column prop="expirationDate" label="到期时间">
        <template #default="scope">
          {{ scope.row.expirationDate }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/admin/hosts';
import utils from '@/utils';
import { IHostCert, IHostDomain } from '@/types/models';
import { HOST_DOMAIN_HONGKONG, HOST_DOMAIN_MAINLAND } from '@/const';

interface IState {
  hostName: string;
  nodeName: string;
  isHongKong: boolean;
  uniqueName: string;
  nickName: string;
  domains: IHostDomain[];
  certs: IHostCert[];
  errorMessage: string;
}

export default defineComponent({
  name: 'Domains',
  props: {
    userName: {
      type: String,
      required: true,
    },
    hostId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hostName: '',
      nodeName: '',
      isHongKong: false,
      uniqueName: '',
      nickName: '',
      domains: [],
      certs: [],
      errorMessage: '',
    } as IState;
  },
  methods: {
    apiGet() {
      api.getCerts(this.userName, this.hostId, (res) => {
        if (!res) return;
        this.hostName = res.hostName;
        this.nodeName = res.nodeName;
        this.isHongKong = res.isHongKong;
        this.uniqueName = res.uniqueName;
        this.nickName = res.nickName;
        this.domains = res.domains;
        this.certs = res.certs;
      });
    },

    getCName() {
      const hostDomain = this.isHongKong ? HOST_DOMAIN_HONGKONG : HOST_DOMAIN_MAINLAND;
      return `${this.nodeName}.${hostDomain}`;
    },

    getHostUrl(): string {
      return utils.getHostUrl(this.hostName, this.nodeName, this.isHongKong);
    },

    isHttps(url: string) {
      return !!(url && url.startsWith('https://'));
    },

    getDomain(url: string) {
      const r = /:\/\/(.[^/]+)/;
      const arr = (url || '').match(r);
      return arr && arr.length > 1 ? arr[1] : '';
    },
  },
  watch: {
    hostId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
